export default __webpack_public_path__ + "static/media/moodle.9eddefa0.svg";